import React from 'react';
import PropTypes from 'prop-types';
import { useInRouterContext, useLocation } from 'react-router-dom';
import UnlockSheet from './UnlockSheet.jsx';
import useUnlocks from '../../hooks/useUnlocks';

/**
 * Ebene fuer neue Otter-Teile (Aura v2): steckt neben der LevelUpCelebration im
 * NotificationProvider und verbindet useUnlocks mit dem UnlockSheet.
 *
 * Nicht ueberall: In einer laufenden Session, im Fokus-Modus, im Chat, beim
 * QR-Scan und im Profil-Setup wartet das Sheet (auch ein nachgeholtes Level) auf
 * den naechsten ruhigen Moment. Dieselbe Liste wie in legal/ResearchConsentGate.jsx.
 *
 * Ohne Router (Tests, oeffentliche Seiten) rendert die Ebene nichts.
 */
const BUSY_ROUTES = [/^\/session\//, /^\/focus-session\//, /^\/chat\//, /^\/scan-qr/, /^\/scan-invitation/, /^\/profile-setup/];

export const isBusyRoute = (pathname) => BUSY_ROUTES.some((pattern) => pattern.test(pathname || ''));

const Layer = ({
  userId, level, refreshSignal, celebratedLevel, levelUpOpen, onLevel,
}) => {
  const { pathname } = useLocation();
  const {
    sheet, wardrobe, wear, setVisibility, closeSheet,
  } = useUnlocks({
    userId,
    quiet: !isBusyRoute(pathname),
    refreshSignal,
    celebratedLevel,
    levelUpOpen,
    onLevel,
  });

  if (!sheet) return null;
  return (
    <UnlockSheet
      // Neuer Inhalt = frisches Sheet (Schritt, Hinweise)
      key={sheet.items.map((item) => item.key).join('|')}
      open
      items={sheet.items}
      level={level}
      outfit={wardrobe?.outfit || {}}
      askVisibility={sheet.askVisibility}
      onWear={wear}
      onVisibility={setVisibility}
      onClose={closeSheet}
    />
  );
};

const UnlockLayer = (props) => {
  const inRouter = useInRouterContext();
  if (!inRouter || !props.userId) return null;
  return <Layer {...props} />;
};

UnlockLayer.propTypes = {
  userId: PropTypes.string,
  level: PropTypes.number,
  refreshSignal: PropTypes.number,
  celebratedLevel: PropTypes.number,
  levelUpOpen: PropTypes.bool,
  onLevel: PropTypes.func,
};

Layer.propTypes = UnlockLayer.propTypes;

export default UnlockLayer;
